import { Button } from "../../components/ui/btns/Button"
import { useNavigate } from "react-router-dom";

export const AdminHome = () => {
    let navigate = useNavigate();

    const navigateToCreate = () => {
        navigate('/admin/create');
    }

    return (
        <div className="min-h-[60vh] flex items-center justify-center bg-flyers-black p-6">
            <div className="text-center space-y-6">
                <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
                    Admin Panel
                </h1>
                <Button onClick={navigateToCreate}>Create Something</Button>
            </div>
        </div>
    )
}
